import { PageResult } from '../../models/CoreModels';
import { Action, Reducer } from 'redux';
import { CacheRequestState, RequestState } from '../../models/RequestState';
import { OneRosterSchoolUnit } from '../../models/CoreOneRosterModels'
import InstanceClient from '../../services/InstanceClient';
import StatusCode from '../../util/StatusCode';
import store from '../store';
import { SearchPageRequest } from '../../models/Requests';
import { Dispatch } from 'react';

enum OneRosterSchoolUnitActionType {
    ONEROSTER_SCHOOLUNITS = 'ONEROSTER_SCHOOLUNITS',
    ONEROSTER_SCHOOLUNITS_UPDATE = 'ONEROSTER_SCHOOLUNITS_UPDATE',
    ONEROSTER_SCHOOLS_FILTER = 'ONEROSTER_SCHOOLS_FILTER',
    ONEROSTER_SCHOOLUNIT = 'ONEROSTER_SCHOOLUNIT'
}

export interface OneRosterSchoolUnitState {
    schoolUnits: CacheRequestState<PageResult<OneRosterSchoolUnit>>
    filter: Partial<SearchPageRequest>
    schoolUnit: RequestState<OneRosterSchoolUnit>
};

interface OneRosterSchoolUnit_ListSchoolUnitsBase extends Action<OneRosterSchoolUnitActionType> {
    type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNITS,
    schoolUnits: CacheRequestState<PageResult<OneRosterSchoolUnit>>
};
interface OneRosterSchoolUnit_ListSchoolUnitsFilter extends Action<OneRosterSchoolUnitActionType> {
    type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLS_FILTER,
    filter: Partial<SearchPageRequest>
};
interface OneRosterSchoolUnit_ListSchoolUnitsUpdate extends Action<OneRosterSchoolUnitActionType> {
    type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNITS_UPDATE
};

type OneRosterSchoolUnit_ListSchoolUnits = OneRosterSchoolUnit_ListSchoolUnitsBase
    | OneRosterSchoolUnit_ListSchoolUnitsFilter
    | OneRosterSchoolUnit_ListSchoolUnitsUpdate;

interface OneRosterSchoolUnit_GetSchoolUnit extends Action<OneRosterSchoolUnitActionType> {
    type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNIT,
    schoolUnit: RequestState<OneRosterSchoolUnit>
}

export const getOneRosterSchoolUnits = (filter: Partial<SearchPageRequest> = {}, update = false) => (dispatch: Dispatch<OneRosterSchoolUnit_ListSchoolUnits>) => {
    dispatch({
        type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLS_FILTER,
        filter: filter,
    });
    if (update) {
        dispatch({ type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNITS_UPDATE });
    }

    const url = '/api/core/oneroster/org';
    InstanceClient.get<PageResult<OneRosterSchoolUnit>>(url, filter)
        .then(res => {
            dispatch({
                type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNITS,
                schoolUnits: {
                    code: StatusCode.COMPLETE,
                    data: res.data
                },
            })
        })
        .catch(error =>
            dispatch({
                type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNITS,
                schoolUnits: { code: StatusCode.ERROR, error }
            })
        )
}

export const getOneRosterSchoolUnit = (id: string) => (dispatch: Dispatch<OneRosterSchoolUnit_GetSchoolUnit>) => {
    const storeKey = store.getState().onerosterSchoolunit.schoolUnit.key;
    const key = id;
    if (key === storeKey) {
        return;
    }

    const url = '/api/core/oneroster/org/' + id;
    InstanceClient.get<OneRosterSchoolUnit>(url)
        .then(res => {
            dispatch({
                type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNIT,
                schoolUnit: { code: StatusCode.COMPLETE, data: res.data, key: key },
            })
        })
        .catch(error =>
            dispatch({
                type: OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNIT,
                schoolUnit: { code: StatusCode.ERROR, error }
            })
        )
};

type OneRosterSchoolUnitAction = OneRosterSchoolUnit_ListSchoolUnits
    | OneRosterSchoolUnit_GetSchoolUnit;

const initialState: OneRosterSchoolUnitState = {
    schoolUnits: { code: StatusCode.PENDING },
    schoolUnit: { code: StatusCode.PENDING },
    filter: {},
}

export const reducer: Reducer<OneRosterSchoolUnitState, OneRosterSchoolUnitAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNITS:
            return {
                ...state,
                schoolUnits: action.schoolUnits,
            }
        case OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNITS_UPDATE:
            return {
                ...state,
                schoolUnits: { ...state.schoolUnits, code: StatusCode.PENDING }
            }
        case OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLS_FILTER:
            return {
                ...state,
                filter: action.filter
            }
        case OneRosterSchoolUnitActionType.ONEROSTER_SCHOOLUNIT:
            return {
                ...state,
                schoolUnit: action.schoolUnit
            }
        default:
            return state;
    }
};
